module.exports = __webpack_public_path__ + "img/88db4e7.png";